
 export const plans = [
    {
      name: "Starter",
      price: 12,
      features: [
        "One Day Trial",
        "Limited Courses",
        "Free 3 Lessons",
        "No Supporter",
        "No Ebook",
        "No Tutorial",
        "Limited Registered User",
      ],
    },
    {
      name: "Basic",
      price: 35,
      features: [
        "One Day Standard Access",
        "Limited Courses",
        "300+ Lessons",
        "Random Supporter",
        "View Only Ebook",
        "Standard Tutorials",
        "Unlimited Registered User",
      ],
    },
    {
      name: "Premium",
      price: 60,
      features: [
        "Unlimited Registered User",
        "Unlimited Courses",
        "1000+ Lessons & Growing ",
        "Random Supporter",
        "Free Ebook Downloads",
        "Premium Tutorials",
        "Unlimited Registered User",
      ],
    },
  ];
  